// Textos de la interfaz (regla f de reglas-ui-ux): todo texto con t("clave"); la base en inglés, en en.json.
import en from './en.json';

type Dict = Record<string, string>;
const base: Dict = en;

export function t(key: string, vars?: Record<string, string | number>): string {
  const s = base[key];
  if (s === undefined) {
    if (import.meta.env.DEV) console.warn(`i18n: falta la clave ${key}`);
    return key;
  }
  return vars ? s.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? `{${k}}`)) : s;
}
